<work-ui-modal #personaldossierModal
             [showInlineBorders]="true"
             [titleText]="(entryToUpdate() ? 'PERSONALDOSSIER_EINTRAG_ACTION' : 'PERSONALDOSSIER_NEUER_EINTRAG') | translate: {action: 'BEARBEITEN' | translate}"
             modalId="personaldossierModal"
             modalWidth="large">
  <ng-container modal-body>
    @if (personaldossierModal.isOpen) {
      @if (!entryToUpdate()) {
        <form (ngSubmit)="createEntry()" [formGroup]="formGroupCreate" autocomplete="off">
          <work-ui-select (valueChanged)="formGroupCreate.patchValue({categoryId: $event})"
                          [options]="categoryOptions()"
                          formControlName="categoryId"
                          id="sfgPersonaldossierCreateCategoryId"
                          label="PERSONALDOSSIER_KATEGORIE" />
          <work-ui-input-datepicker formControlName="entryDate"
                                    label="PERSONALDOSSIER_DATUM" />
          <work-ui-input-field formControlName="subject"
                               label="PERSONALDOSSIER_BETREFF" />
          <work-ui-input-field formControlName="notes"
                               label="PERSONALDOSSIER_NOTIZEN"
                               variant="textarea" />
        </form>
      }
      @if (entryToUpdate()) {
        <form (ngSubmit)="updateEntry()" [formGroup]="formGroupUpdate" autocomplete="off">
          <work-ui-select (valueChanged)="formGroupUpdate.patchValue({categoryId: $event})"
                          [options]="categoryOptions()"
                          formControlName="categoryId"
                          id="sfgPersonaldossierUpdateCategoryId"
                          label="PERSONALDOSSIER_KATEGORIE" />
          <work-ui-input-datepicker formControlName="entryDate"
                                    label="PERSONALDOSSIER_DATUM" />
          <work-ui-input-field formControlName="subject"
                               label="PERSONALDOSSIER_BETREFF" />
          <work-ui-input-field formControlName="notes"
                               label="PERSONALDOSSIER_NOTIZEN"
                               variant="textarea" />
        </form>
      }
    }
  </ng-container>
  <ng-container modal-footer>
    @if (!entryToUpdate()) {
      <work-ui-button (buttonClick)="createEntry()"
                      [(loadingState)]="formSaveLoadingState"
                      [disabled]="formGroupCreate.invalid || formGroupCreate.untouched"
                      [showLoadingOnClick]="true"
                      [text]="'ERSTELLEN' | translate" />
    }
    @if (entryToUpdate()) {
      <work-ui-button (buttonClick)="updateEntry()"
                      [(loadingState)]="formSaveLoadingState"
                      [disabled]="formGroupUpdate.invalid || formGroupUpdate.untouched"
                      [showLoadingOnClick]="true"
                      [text]="'SPEICHERN' | translate" />
    }
    <work-ui-button (click)="personaldossierModal.close()"
                    [text]="'SCHLIESSEN' | translate"
                    variant="secondary" />
  </ng-container>
</work-ui-modal>
